/*
 * Angular 2 decorators and services
 */
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppState } from './app.service';
import { MemberUserService } from './services/http/member-user.service';

/*
 * App Component
 * Top Level Component
 */
@Component({
  selector: 'app',
  template: ` <router-outlet></router-outlet>`,
  encapsulation: ViewEncapsulation.None,
  styles: [ require('./scss/application.scss') ]
})
export class AppComponent implements OnInit {
  public angularclassLogo = 'assets/img/angularclass-avatar.png';
  public name = 'Angular 2 Webpack2 Bootstrap4 Starter';
  public url = 'http://rcc-uat-api.azurewebsites.net';

  constructor(
    public appState: AppState,
    private memberUserService:MemberUserService
  ) {}

  public ngOnInit() {
    console.log('Initial App State', this.appState.state);
    // this.memberUserService.getMe();
    // this.memberUserService.getMyClub();
    // this.memberUserService.getMyOrgHierarchy();
  }
  
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/app.component.ts